import React from "react";
import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";

const ClientBlogs = () => {
  return (
    <>
      <ClientHeader />
      <main className="overflow-hidden mt-2">
        
        {/* HERO SECTION */}
        <section className="homepad-about py-5" style={{ backgroundColor: "#083B5C" }}>
          <div className="container py-lg-5 text-center">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <h1 className="font-weight-bold montserrat text-white mb-3" style={{ fontSize: "3.5rem", lineHeight: "1.1" }}>
                  News & Insights
                </h1>
                <p className="text-white opacity-75 font-size-18 mb-0">
                  Stories, updates, and resources from The Just Generation Foundation.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FEATURED BLOG SECTION */}
        <section className="py-5 mt-4">
          <div className="container">
            <h4 className="font-weight-bold text-primary mb-4">Featured Article</h4>
            <div className="card border-0 shadow-lg rounded-4 overflow-hidden mb-5">
              <div className="row g-0">
                <div className="col-lg-6">
                  {/* Placeholder Image */}
                  <div className="w-100 h-100" style={{ backgroundColor: "#f4f7f6", minHeight: "350px" }}></div>
                </div>
                <div className="col-lg-6 d-flex align-items-center">
                  <div className="card-body p-4 p-md-5">
                    <div className="d-flex align-items-center mb-3">
                      <span className="badge bg-success text-white px-3 py-2 rounded-pill font-size-12 font-weight-bold text-uppercase me-3">Community</span>
                      <span className="text-muted font-size-14">October 24, 2024</span>
                    </div>
                    <h2 className="font-weight-bold text-primary font-size-32 mb-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</h2>
                    <p className="text-muted font-size-16 line-hight-3 mb-4">
                      Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    </p>
                    <a href="/blog/1" className="btn btn-outline-primary font-weight-bold px-4 py-2 rounded-3">Read Full Article</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* LATEST ARTICLES GRID */}
        <section className="py-4 mb-5">
          <div className="container">
            <h4 className="font-weight-bold text-primary mb-4">Latest Articles</h4>
            <div className="row g-4">
              
              {/* Blog Card 1 */}
              <div className="col-md-6 col-lg-4">
                <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden">
                  <div className="w-100" style={{ backgroundColor: "#e9ecef", height: "220px" }}></div>
                  <div className="card-body p-4">
                    <span className="text-success font-size-13 font-weight-bold text-uppercase d-block mb-2">Education</span>
                    <h4 className="font-weight-bold font-size-22 mb-3">Ut enim ad minim veniam, quis nostrud.</h4>
                    <p className="text-muted font-size-15 mb-0">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                  </div>
                </div>
              </div>

              {/* Blog Card 2 */}
              <div className="col-md-6 col-lg-4">
                <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden">
                  <div className="w-100" style={{ backgroundColor: "#e9ecef", height: "220px" }}></div>
                  <div className="card-body p-4">
                    <span className="text-success font-size-13 font-weight-bold text-uppercase d-block mb-2">Events</span>
                    <h4 className="font-weight-bold font-size-22 mb-3">Excepteur sint occaecat cupidatat non proident.</h4>
                    <p className="text-muted font-size-15 mb-0">Sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error.</p>
                  </div>
                </div>
              </div>

              {/* Blog Card 3 */}
              <div className="col-md-6 col-lg-4">
                <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden">
                  <div className="w-100" style={{ backgroundColor: "#e9ecef", height: "220px" }}></div>
                  <div className="card-body p-4">
                    <span className="text-success font-size-13 font-weight-bold text-uppercase d-block mb-2">Updates</span>
                    <h4 className="font-weight-bold font-size-22 mb-3">Nemo enim ipsam voluptatem quia voluptas.</h4>
                    <p className="text-muted font-size-15 mb-0">Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
      <ClientFooter />
    </>
  );
};

export default ClientBlogs;